<template>
	<div class="concept">
		<div v-if="$i18n.locale =='en'" class="ma-4">
			<v-row justify="center">
				<h1>404</h1>
			</v-row>
			<v-row justify="center">
				<h3>Page not found</h3>
			</v-row>
		</div>
	</div>
</template>
<script>
	import moment from 'moment';
	export default {
		name: 'concept',
		components: {
		},
		data:function(){
			return{
				images:{
					concept: require('@/assets/remotelab-concept.png'),
				},
			}
		},
		mounted: function(){
			var self = this;
		},
		methods:{
		}
	}
</script>
